import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import CommonTable from 'components/elements/tables/common-table/CommonTable';
import BillingInvoicesListItem
  from 'components/dashboard/billing-content/BillingInvoicesListItem';

import './BillingInvoicesList.css';

const BillingInvoicesList = ({ billingInvoices }) => (
  <Translation>
    {(t) => (
      <div className="billing-invoices-list__component">
        <CommonTable className="mobile-1024">
          <CommonTable.Header>
            <CommonTable.Cell>{t("Invoice Date")}</CommonTable.Cell>
            <CommonTable.Cell>{t("Amount")}</CommonTable.Cell>
            <CommonTable.Cell>{t("Description")}</CommonTable.Cell>
            <CommonTable.Cell>{t("Invoice")}</CommonTable.Cell>
          </CommonTable.Header>
          {billingInvoices.map(item => (
            <BillingInvoicesListItem
              key={`billing-invoices-list-item-key-${item.id}`}
              item={item}
            />
          ))}
        </CommonTable>
      </div>
    )}
  </Translation>
);

BillingInvoicesList.propTypes = {
  billingInvoices: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default BillingInvoicesList;
